<template>
  <div class="bg-hover">
    <div class="relative z-1">
      <div
        v-for="item in items"
        class="bg-hover__item"
        :class="{ 'is-active' : activeItem === item.key }"
        :key="item.key"
        :style="{ backgroundImage: `url(${item.image})`}"
      ></div>
    </div>

    <div class="relative z-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BackgroundHover",

  props: {
    items: Array
  },

  data() {
    return {
      activeItem: null
    }
  },

  methods: {
    setActiveItem(item) {
      this.activeItem = item
    }
  }
}
</script>

<style scoped>
.bg-hover__item {
  display: none;
}

@media screen and (min-width: 60em) {
  .bg-hover__item {
    display: block;
    background-size: cover;
    position: fixed;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 110px;
    right: 0;
    opacity: 0;
    transition: opacity 250ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }

  .bg-hover__item.is-active {
    opacity: 1;
    transition: opacity 350ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }
}
</style>
